import { useFeatureFlag } from "../useFeatureFlag/useFeatureFlag";
import { Flags } from "../../feature-flags/flags";
import { MARK_BRAND_NAME, OPAL_BRAND_NAME, renameOpalCopy } from "../../lib/opal-branding";

// Resolves the brand name for user facing copy. While rename_opal is off the copy keeps reading
// OPAL_BRAND_NAME; once it is on the same copy reads MARK_BRAND_NAME.
//
// Use `opalName` for copy authored in the component, and `renameOpalCopy` for copy that arrives
// already composed (route titles, page descriptions, tooltips).
export const useOpalBranding = () => {
    const { enabled } = useFeatureFlag(Flags.RENAME_OPAL);

    return {
        renameEnabled: enabled,
        opalName: enabled ? MARK_BRAND_NAME : OPAL_BRAND_NAME,
        renameOpalCopy: (copy: string) => renameOpalCopy(copy, enabled)
    };
};
